import { api } from 'constants/constant';
import { getHeaders, getExcelHeaders } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const qualityCheckAPI = createApi({
  reducerPath: 'qualityCheck',
  tagTypes: ['fetchQualityCheck'],
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getChecklist: builder.query({
      query: ({ applicationId, userId }) => {
        return {
          url: `/b2b/loan/quality_check/quality_document_verified?user_id=${userId}&application_id=${applicationId}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),

    getGenerateExcel: builder.query({
      query: ({ applicationId }) => {
        return {
          url: `/b2b/loan/quality_check/post_quality?application_id=${applicationId}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),

    getDownloadExcel: builder.query({
      query: ({ applicationId }) => {
        return {
          url: `/b2b/loan/quality_check/download_qc_doc?application_id=${applicationId}`,
          method: 'GET',
          headers: getExcelHeaders(),
          responseHandler: (response) => response.arrayBuffer(), // treat as binary data
        };
      },
    }),
  }),
});

export const {
  useGetChecklistQuery,
  useGetGenerateExcelQuery,
  useGetDownloadExcelQuery,
} = qualityCheckAPI;
